import { Doughnut } from "react-chartjs-2";
import type { SessionDetail } from "../../../types";
import { useTheme, chartColors } from "../../../theme";

interface Props {
  details: SessionDetail[];
}

export default function ErrorBreakdownChart({ details }: Props) {
  useTheme(); // re-render on theme change so the palette below is re-resolved
  const c = chartColors();

  const options = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: { legend: { position: "bottom" as const, labels: { color: c.legend, boxWidth: 12, font: { size: 12 }, padding: 16 } } },
  } as const;

  const totals = details.reduce(
    (acc, d) => {
      acc.grammar += d.metrics?.grammar_errors ?? 0;
      acc.vocabulary += d.metrics?.vocabulary_errors ?? 0;
      acc.pronunciation += d.metrics?.pronunciation_flags ?? 0;
      acc.syntax += d.metrics?.syntax_errors ?? 0;
      return acc;
    },
    { grammar: 0, vocabulary: 0, pronunciation: 0, syntax: 0 }
  );

  const data = {
    labels: ["Grammar", "Vocabulary", "Pronunciation", "Syntax"],
    datasets: [{
      data: [totals.grammar, totals.vocabulary, totals.pronunciation, totals.syntax],
      backgroundColor: ["#3B82C4", "#C89B3C", "#D46A5A", "#5E8F87"],
      borderColor: c.surface,
      borderWidth: 2,
    }],
  };

  return (
    <div className="h-[260px]">
      <Doughnut data={data} options={options} />
    </div>
  );
}
